import { useQueryClient } from "@tanstack/react-query";
import { offerServices } from "features/offer/services/offer.service";

export const usePrefetchOffer = () => {
    const queryClient = useQueryClient();

    const prefetchOffers = (params) => {
        queryClient.prefetchQuery({
            queryKey: ["offers", params],
            queryFn: () => offerServices.getOffers(params),
            staleTime: 5 * 60 * 1000,
        });
    };

    const prefetchNextPage = (currentParams, totalPages) => {
        const currentPage = parseInt(currentParams.page);
        if (currentPage < totalPages) {
            prefetchOffers({ ...currentParams, page: String(currentPage + 1) });
        }
    };

    const prefetchPrevPage = (currentParams) => {
        const currentPage = parseInt(currentParams.page);
        if (currentPage > 1) {
            prefetchOffers({ ...currentParams, page: String(currentPage - 1) });
        }
    };

    return {
        prefetchOffers,
        prefetchNextPage,
        prefetchPrevPage,
    };
}